import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import Global from "../plugins/global";
import { encryptData, decryptData } from '../helpers/crypto'
import swal from 'sweetalert2';

let isRefreshing = false;
let failedQueue = [];

function processQueue(error, token = null) {
  failedQueue.forEach(prom => {
    if (error) prom.reject(error);
    else prom.resolve(token);
  });
  failedQueue = [];
}

Vue.use(Vuex);
Vue.use(Global);
//axios.defaults.baseURL = 'http://data.exactmatchmarketing.local/api'
//axios.defaults.baseURL = 'https://databeta.exactmatchmarketing.com/api'
axios.defaults.baseURL = process.env.VUE_APP_DATASERVER_URL + "/api";

axios.interceptors.response.use(
  response => response,
  async error => {
    if(error.response.data.message == 'Unauthenticated.' 
        && localStorage.getItem('access_token') 
        && localStorage.getItem('refresh_token')
        && !error.config._retry ) {
      
      const originalRequest = error.config;
      originalRequest._retry = true;

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then(token => {
          originalRequest.headers['Authorization'] = 'Bearer ' + token;
          return axios(originalRequest);
        });
      }

      isRefreshing = true;

      try {
        const res = await axios.post('/auth/refresh-token', {
          refresh_token: localStorage.getItem('refresh_token'),
        });

        const { access_token, refresh_token: newRefresh, expires_in } = res.data;

        localStorage.setItem('access_token', access_token);
        localStorage.setItem('refresh_token', newRefresh);
        localStorage.setItem('expires_in', expires_in);
        store.commit("retrieveToken", access_token);
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token;

        processQueue(null, access_token);

        originalRequest.headers['Authorization'] = 'Bearer ' + access_token;
        return axios(originalRequest);
      } catch (err) {
        processQueue(err, null);

      setTimeout(() => {
        const container = document.querySelector('.swal2-container');
        const popup = document.querySelector('.swal2-popup');
        if (container) container.style.zIndex = '99998';
        if (popup) popup.style.zIndex = '99999';
      }, 50);
      const result = await swal.fire({
        title: 'Session Ended',
        text: 'Your session has ended. Please log in again to continue.',
        icon: 'error',
        confirmButtonText: 'OK',
      });

      localStorage.clear();
      localStorage.removeItem('access_token');
      window.location.href = '/login';
      return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }
    return Promise.reject(error);
  }
);

var global = Vue.prototype.$global;
var _clientIP = localStorage.getItem("clientIP");

function fetchClientIP() {
  fetch("https://www.cloudflare.com/cdn-cgi/trace")
    .then(response => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.text();
    })
    .then(data => {
      const lines = data.split("\n");
      const details = {};
      lines.forEach(line => {
        const [key, value] = line.split("=");
        details[key] = value;
      });

      // Accessing the client's IP address
      const clientIPAddress = details["ip"];
      localStorage.setItem("clientIP", clientIPAddress);
      axios.interceptors.request.use(
        function(config) {
          // Add "clientip" header to the request
          config.headers["clientip"] =
            clientIPAddress +
            "|" +
            Intl.DateTimeFormat().resolvedOptions().timeZone; // Replace with the actual client IP
          config.headers[
            "cltmz"
          ] = Intl.DateTimeFormat().resolvedOptions().timeZone;
          return config;
        },
        function(error) {
          return Promise.reject(error);
        }
      );
    })
    .catch(error => {
      console.error("Error:", error);
    });
}

if (_clientIP === null || _clientIP == "") {
  fetchClientIP();
} else {
  axios.interceptors.request.use(
    function(config) {
      // Add "clientip" header to the request
      config.headers["clientip"] =
        _clientIP + "|" + Intl.DateTimeFormat().resolvedOptions().timeZone; // Replace with the actual client IP
      config.headers[
        "cltmz"
      ] = Intl.DateTimeFormat().resolvedOptions().timeZone;
      return config;
    },
    function(error) {
      return Promise.reject(error);
    }
  );
}

function getUserDataFromLocalStorage() {
  const storedData = localStorage.getItem("userData");

  if (!storedData) {
    return {};
  }

  try {
    const parsedData = JSON.parse(storedData)

    if((parsedData.systemuser && parsedData.rootcomp) || parsedData.isViewMode){
      // Only root EMM / View mode root EMM not encrypt
      return parsedData
    } else {
      localStorage.removeItem('access_token');
      localStorage.removeItem('userData');
      window.location.href = '/login'
    }
  } catch (error) {
    // If parsing fails, it means the data is probably encrypted
  }

  return decryptData(storedData)
}

function setupAutoRefresh() {
  const expiresIn = parseInt(localStorage.getItem('expires_in') || '3600'); // in seconds
  // const refreshBefore = 5 * 60 * 1000; // 5 menit sebelum expired
  const refreshBefore = 1 * 60 * 1000; // 5 menit sebelum expired
  const refreshTime = (expiresIn * 1000) - refreshBefore;

  setTimeout(async () => {
    if (isRefreshing) return; // ⬅ cegah double refresh
    isRefreshing = true;

    const refreshToken = localStorage.getItem('refresh_token');
    if (!refreshToken) return;

    try {
      const res = await axios.post('/auth/refresh-token', {
        refresh_token: refreshToken
      });

      const { access_token, refresh_token: newRefresh, expires_in } = res.data;

      localStorage.setItem('access_token', access_token);
      localStorage.setItem('refresh_token', newRefresh);
      localStorage.setItem('expires_in', expires_in);
      axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;

      isRefreshing = false;
      setupAutoRefresh(); // repeat
    } catch (err) {
      localStorage.clear();
      window.location.href = '/login';
    }
  }, refreshTime);
}

export const store = new Vuex.Store({
  state: {
    token: localStorage.getItem("access_token") || null,
    userData: getUserDataFromLocalStorage(),
    isRefreshing: false,
    resultData: {}
  },
  getters: {
    loggedIn(state) {
      return state.token !== null;
    },
    userCompletedSetup(state) {
      return state.userData.profile_setup_completed !== null;
    },
    userData(state) {
      return state.userData;
    },
    resultData(state) {
      return state.resultData;
    },
    getUserType(state) {
      return state.userData.user_type;
    }
  },  
  mutations: {
    setRefreshing(state, status) {
      state.isRefreshing = status;
    },
    retrieveToken(state, token) {
      state.token = token;
    },
    destroyToken(state) {
      state.token = null;
      state.userData = null;
    },
    retrieveUser(state, data) {
      state.userData = data;
      if((data.systemuser && data.rootcomp) || data.isViewMode){
        // Only root EMM / View mode root EMM not encrypt
        return localStorage.setItem("userData", JSON.stringify(data));
      }

      const encryptedData = encryptData(data);
      localStorage.setItem("userData", encryptedData);
    },
    putResultData(state, data) {
      state.resultData = data;
    },
    updateUserData(state, newData) {
      let userData = state.userData || {};
      userData = { ...userData, ...newData };
      state.userData = userData;

      if((userData.systemuser && userData.rootcomp) || userData.isViewMode){
        // Only root EMM / View mode root EMM not encrypt
        return localStorage.setItem("userData", JSON.stringify(userData));
      }

      const encryptedData = encryptData(userData);
      localStorage.setItem('userData', encryptedData);
    }
  },
  actions: {
    updateUserData({ commit }, newData) {
      commit('updateUserData', newData);
    },
    setLogout({ commit }) {
      commit('destroyToken');
      localStorage.removeItem('access_token');
      localStorage.removeItem('userData');
      window.location.href = '/login'
    },
    fetchUserFromLocalStorage() {
      this.state.userData = getUserDataFromLocalStorage();
    },
    getMinimumValueSimplifi(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.get('/configuration/setting/minvaluesimplifi', {
          params: {
            idsys: data.idsys
          }
        })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
      });
    },
    processChargeCampaignByRemainingDays(context, data) {
      return new Promise((resolve, reject) => {
      	axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.post('/leadspeek/simplifi/charge-campaign-by-remaining-days', {
          companyID: data.companyID,
          leadspeekID: data.leadspeekID,
          userID: data.LeadspeekUserId,
          leadspeekMaxBid: data.leadspeekMaxBid,
          leadspeekMonthlyBudget: data.leadspeekMonthlyBudget,
          leadspeekDailyBudget: data.leadspeekDailyBudget,
          leadspeekGoalValue: data.leadspeekGoalValue,
          leadspeekGoalType: data.leadspeekGoalType,
          leadspeekAgencyMarkup: data.leadspeekAgencyMarkup,
          leadspeekRemainingDays: data.leadspeekRemainingDays,
          leadspeekTotalSpend: data.leadspeekTotalSpend,
          costClientByRemainingDays: data.costClientByRemainingDays,
          costAgencyByRemainingDays: data.costAgencyByRemainingDays,
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        })
      });
    },
    checkBudgetSimplifiIncrease(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.get(`/leadspeek/simplifi/check-budget-increase`, {
          params: {
            campaign_action_source: data.campaign_action_source,
            leadspeek_api_id: data.leadspeek_api_id,
            current_daily_budget: data.current_daily_budget,
            current_agency_markup: data.current_agency_markup,
            current_goal_type: data.current_goal_type,
            current_goal_value: data.current_goal_value,
          }
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
      });
    },
    getRemainingBudgetSimplifi(context, data) {
      return new Promise((resolve, reject) => {
        axios.get(`/leadspeek/simplifi/remaining-budget/${data.leadspeek_api_id}`)
             .then(response => {
              resolve(response.data)
             })
             .catch(error => {
              reject(error)
             })
      });
    },
    SimplifiModuleCost(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.put('/leadspeek/simplifi/costmodule', {
          ClientID: data.ClientID,
          LeadspeekMaxBid: data.LeadspeekMaxBid,
          LeadspeekMonthlyBudget: data.LeadspeekMonthlyBudget,
          LeadspeekDailyBudget: data.LeadspeekDailyBudget,
          LeadspeekGoalValue: data.LeadspeekGoalValue,
          LeadspeekGoalType: data.LeadspeekGoalType,
          LeadspeekAgencyMarkup: data.LeadspeekAgencyMarkup,
        })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error);
        })
      });
    },
    ghlv2GetListSubAccountsAll(context, data) {
      return new Promise((resolve, reject) => {
      	axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.get(`/gohighlevelv2/list-subaccounts-all/${data.company_id}`)
            .then(response => {
              resolve(response.data);
            })
            .catch(error => {
              reject(error);
            })
      })
    },
    createClientFromSubAccountLeadConnector(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
      	axios.post('/gohighlevelv2/create-client-from-subaccount', {
          company_id: data.company_id,
          sub_accounts: data.sub_accounts,
          user_ip: data.user_ip
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        })
      });
    },
    ghlv2GetListSubAccounts(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.get(`/gohighlevelv2/list-subaccounts/${data.company_id}`, {
          params: {
            page: data.page,
          }
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        })
      });
    },
    
    createIframeGhlv2Client(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.post('/gohighlevelv2/create-iframe/client', {
          company_id: data.company_id,
          company_parent: data.company_parent,
          custom_menu_name: data.custom_menu_name,
          user_ip: data.user_ip,
          location_id: data.location_id,
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        })
      })
    },
    deleteIframeGhlv2Client(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.delete('/gohighlevelv2/delete-iframe/client', {
          data: {
            company_id: data.company_id,
            company_parent: data.company_parent,
            user_ip: data.user_ip,
          }
        })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error);
        })
      });
    },

    createIframeGhlv2ClientYourAccount(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.post('/gohighlevelv2/create-iframe/client-your-account', {
          company_id: data.company_id,
          subdomain_url: data.subdomain_url,
          enable_sendgrid: data.enable_sendgrid,
          custom_fields_general: data.custom_fields_general,
          custom_fields_b2b: data.custom_fields_b2b,
          custom_fields_advance: data.custom_fields_advance,
          custom_menu_name: data.custom_menu_name,
          user_ip: data.user_ip,
          is_in_iframe: data.is_in_iframe
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        })
      })
    },
    deleteIframeGhlv2ClientYourAccount(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.delete('/gohighlevelv2/delete-iframe/client-your-account', {
          data: {
            company_id: data.company_id,
            user_ip: data.user_ip,
          }
        })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error);
        })
      });
    },

    checkGohighlevelConnect(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
      	axios.get(`/general/check-connected-gohighlevel/${data.companyID}`)
             .then(response => {
              resolve(response.data);
             })
             .catch(error => {
              reject(error);
             })
      });
    },
    getMinimumSpendUser(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.get('/general/minimum-spend-user', {
          params: {
            company_id: data.company_id
          }
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        })
      });
    },
    getMinimumSpendList(context, data) {
      return new Promise((resolve, reject) => {
      	axios.get('/general/minimum-spend-config', {
          params: {
            page: data.page
          }
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        })
      })
    },
    createMinimumSpendConfig(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.post('/general/minimum-spend-config', {
          planName: data.planName,
          months: data.months,
          flatMonth: data.flatMonth,
          ipLogin: data.ipLogin,
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        })        
      });
    },
    updateMinimumSpendConfig(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.put('/general/minimum-spend-config', {
          idMinimumSpend: data.idMinimumSpend,
          planName: data.planName,
          months: data.months,
          flatMonth: data.flatMonth,
          ipLogin: data.ipLogin,
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
      });
    },
    deleteMinimumSpendConfig(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.delete('/general/minimum-spend-config', {
          data: {
            idMinimumSpend: data.idMinimumSpend,
            ipLogin: data.ipLogin,
          }
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        })
      })
    },
    setDefaultMinimumSpendConfig(context, data) {
      return new Promise((resolve, reject) => {
        axios.put('/general/set-default-minimum-spend-config', {
          id: data.id,
          ipLogin: data.ipLogin,
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        })
      });
    },
    estimateRefundCampaignPrepaid(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.get('/leadspeek/client/estimeate-refund-topup', {
          params: {
            leadspeek_api_id: data.leadspeek_api_id
          }
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        })
      });
    },
    refundCampaignPrepaid(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.post('/leadspeek/client/refund-topup', {
          leadspeek_api_id: data.leadspeek_api_id,
          company_id: data.company_id,
          ip_user: data.ip_user,
          timezone: data.timezone,
          payment_type: data.payment_type,
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        })
      });
    },
    onSaveUserLogs(context, data){
        const userData = context.getters.userData;
        
        
        let payload = {
          userID: userData.id,
          action: data.action,
          desc: data.desc,
          userIP: userData.ip_login,
          target_userID: data.target_id,
        }

      const userViewMode = userData.isViewMode ? userData.isViewMode : false;
      const globalviewmode = global.globalviewmode ? global.globalviewmode : false;
      if(userViewMode || globalviewmode){
          const userRoot = decryptData(localStorage.getItem('userDataOri'))
          payload.userID = userRoot.id;
      }
      
      context.dispatch('userLogSaved', { data: payload });
    },
    getCurrentTopupPrepaid(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.get(`/leadspeek/client/local/currenttopup/${data.leadspeek_api_id}`)
             .then(response => {
              resolve(response.data);
             })
             .catch(error => {
              reject(error);
             })
      })
    },
    getPrepaidDirectPayment(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.get('/configuration/agencies/prepaid/get-direct-payment', {
          params: {
            company_id: data.company_id,
            date: data.date
          }
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        })
      });
    },
    getTransactionHistoryDirectPayment(context, data) {
      return new Promise((resolve, reject) => {
      	axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.get('/configuration/agencies/prepaid/get-transaction-history-direct-payment', {
          params: {
            company_id: data.company_id,
            date: data.date
          }
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error)
        })
      });
    },
    stopContinualTopupDirectPayment(context, data) {
      return new Promise((resolve, reject) => {
      	axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.put('/configuration/agencies/prepaid/stop-continual-topup', {
          company_id: data.company_id,
          stop_continual: data.stop_continual,
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        })
      });
    },
    savePrepaidDirectPayment(context, data) {
      return new Promise((resolve, reject) => {
      	axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.post('/configuration/agencies/prepaid/save-prepaid-direct-payment', {
          company_id: data.company_id,
          amount: data.amount,
          custom_amount: data.custom_amount,
          stop_continual: data.stop_continual,
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        })
      });
    },
    chargePrepaidDirectPayment(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.post('/configuration/agencies/prepaid/charge-prepaid-direct-payment', {
          company_id: data.company_id,
          amount: data.amount,
          custom_amount: data.custom_amount,
          stop_continual: data.stop_continual,
          ip_user: data.ip_user,
          timezone: data.timezone,
          payment_type: data.payment_type,
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        })
      });
    },
    GetListAdvanceInformation(context, data) {
      return new Promise((resolve, reject) => {
        axios.get('/configuration/list-advance-information')
             .then(response => {
              resolve(response.data);
             })
             .catch(error => {
              reject(error);
             })
      });
    },
    GetListAdvanceInformationB2B(context, data) {
      return new Promise((resolve, reject) => {
        axios.get('/configuration/list-advance-information-b2b')
             .then(response => {
              resolve(response.data);
             })
             .catch(error => {
              reject(error);
             })
      });
    },
    GetListAdvanceInformationByType(context, data) {
      return new Promise((resolve, reject) => {
        axios.get('/configuration/list-advance-information-type', {
              params: {
               type: data.type, 
              }
            })
             .then(response => {
              resolve(response.data);
             })
             .catch(error => {
              reject(error);
             })
      });
    },
    generateAuthenticateOpenApi(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.post('/v1/developer/create/userapi', {
          companyID: data.companyID,
          email: data.email,
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        })
      });
    },
    getAuthenticateOpenApi(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.get(`/v1/developer/userapi/${data.companyID}`)
             .then(response => {
              resolve(response);
             })
             .catch(error => {
              reject(error);
             })
      });
    },
    getClientMinLeadDayEnhance(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.get('/configuration/setting/minleaddayenhance', {
          params: {
            idSys: data.idSys
          }
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        })
      });
    },
    purgeOptoutList(context, data) {
      return new Promise((resolve, reject) => {
      	axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.delete(`/tools/optout/purge/${data.companyRootId}`)
             .then(response => {
              resolve(response);
             })
             .catch(error => {
              reject(error);
             })
      })
    },
    jobProgress(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.get(`/leadspeek/suppressionlist/progress?leadspeekID=${data.leadspeekID}&companyId=${data.companyId}&leadspeekApiId=${data.leadspeekApiId}&campaignType=${data.campaignType}`)
             .then(response => {
              resolve(response);
             })
             .catch(error => {
              reject(error);
             })
      });
    },
    stopContinualTopUp(context, data) {
      return new  Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.put('/leadspeek/client/local/stopcontinualtopup', {
          leadspeek_api_id: data.leadspeek_api_id,
          lp_limit_freq: data.lp_limit_freq
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
      });
    },
    getRemainingBalanceLeads(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.get(`/leadspeek/client/local/remainingbalanceleads/${data.leadspeek_api_id}`)
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              reject(error);
            })
      });
    },
    /** GENERATE REF LINK */
    CheckRefLink(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .get("/general/referralink/check/" + data.refcode)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    CreateRefLink(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .post("/general/referralink/create", {
            userID: data.userID
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    /** GENERATE REF LINK */

    /** CANCEL SUBSCRIPTION */
    cancelsubscription(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .put("/configuration/cancel-subscription", {
            companyID: data.companyID
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    /** CANCEL SUBSCRIPTION */

    /** MANUAL AGENCY BILLING */
    agencyManualBill(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .put("/payment/set-billing-method", {
            companyID: data.companyID,
            manualBill: data.manualBill
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    /** MANUAL AGENCY BILLING */

    /** GOHIGHLEVEL */
    getGhlUserTags(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .get(
            "/gohighlevel/usertags/" + data.campaignID + "/" + data.companyID, {
              params: {
                ip_user: data.userIP
              }
            }
          )
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    getGoHighLevelTags(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .get("/gohighlevel/tags/" + data.companyID)
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    /** GOHIGHLEVEL */

    /* MAILBOXPOWER */
    getMailBoxPowerGroups(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .get("/mailboxpower/groups/" + data.campaignID + "/" + data.companyID)
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    getMailBoxPowerUserGroups(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .get("/mailboxpower/usergroups/" + data.campaignID + "/" + data.companyID)
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    /* MAILBOXPOWER */

    /** ARCHIVE CAMPAIGN */
    archiveCampaign(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .put("/leadspeek/client/archive", {
            lpuserid: data.lpuserid,
            status: data.status
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    /** ARCHIVE CAMPAIGN */
    /** COMPANY GROUP */
    RemoveCompanyGroup(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .delete("/company/group/remove/" + data.companyGroupID)
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    AddEditGroupCompany(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .post("/company/group", {
            companyGroupID: data.companyGroupID,
            companyGroupName: data.companyGroupName,
            companyID: data.companyID,
            moduleID: data.moduleID
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    GetCompanyGroup(context, data) {
      return new Promise((resolve, reject) => {
        var _companyID = "";
        var _userModule = "";

        if (data.companyID != "") {
          _companyID = data.companyID;
        }
        if (
          data.companyID != "" &&
          data.userModule != "" &&
          typeof data.userModule != "undefined"
        ) {
          _userModule = "/" + data.userModule;
        }

        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .get("/company/group/" + _companyID + _userModule)
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    /** COMPANY GROUP */

    /** PAYMENT CUSTOMER */
    processUpdateCard(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .put("/payment/card", {
            tokenid: data.tokenid,
            cardholder: data.cardholder,
            address: data.address,
            city: data.city,
            state: data.state,
            country: data.country,
            zip: data.zip,
            usrID: data.usrID,
            companyParentID: data.companyParentID,
            action: data.action,
            document_type: data.document_type,
            ip_user: data.ip_user,
            timezone: data.timezone,
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    clearPaymentStatus(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .put("/payment/clear-payment-status", {
            usrID: data.usrID,
            companyParentID: data.companyParentID,
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    getCardInfo(context, data) {
      return new Promise((resolve, reject) => {
        var _userID = "";

        if (
          typeof data != "undefined" &&
          data.usrID != "" &&
          typeof data.usrID != "undefined"
        ) {
          _userID = "/" + data.usrID;
        }

        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .get("/payment/card" + _userID)
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    paymentcustomersetup(context, data) {
      return new Promise((resolve, reject) => {
        const payload = {
          tokenid: data.tokenid,
          cardholder: data.cardholder,
          address: data.address,
          city: data.city,
          state: data.state,
          country: data.country,
          zip: data.zip,
          usrID: data.usrID,
          action: data.action,
          amount: data.amount || '',
          document_type: data.document_type,
          from: data.from || '',
        };

        if (data.code && data.code.trim() !== '') {
          payload.code = data.code;
        }

        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .post("/payment/customer", payload)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    paymentdirectcustomersetup(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .post("/payment/customer-direct", {
            usrID: data.usrID
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    /** PAYMENT CUSTOMER */

    /** LEADSPEEK */
    /** REPORT DASHBOARD */

    GetLeadsPeekInvReport(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .get(
            "/leadspeek/report/invoice/" +
              data.companyID +
              "/" +
              data.clientID +
              "/" +
              data.startDate +
              "/" +
              data.endDate
          )
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    GetLeadsPeekLeadReport(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .get(
            "/leadspeek/report/lead/" +
              data.companyID +
              "/" +
              data.clientID +
              "/" +
              data.startDate +
              "/" +
              data.endDate,
              {
                params: {
                  Page: data.page,
                  PerPage:data.perPage,
                  sortby: data.sortby,
                  order: data.order,
                  moduleType: data.moduleType,
                  searchQuery: data.searchQuery,
                  groupCompanyID: data.groupCompanyID
                }
              }
          )
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    GetLeadsPeekInitDate(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .get(
            "/leadspeek/report/initdate/" + data.companyID + "/" + data.clientID, {
              params: {
                moduleType: data.moduleType,
                groupCompanyID: data.groupCompanyID,
              }
            }
          )
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    GetLeadsPeekChartReport(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .get(
            "/leadspeek/report/chart/" +
              data.companyID +
              "/" +
              data.clientID +
              "/" +
              data.startDate +
              "/" +
              data.endDate, {
                params: {
                  moduleType: data.moduleType,
                  groupCompanyID: data.groupCompanyID,
                }
              }
          )
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    /** REPORT DASHBOARD */

    activepauseLeadsPeek(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .put("/leadspeek/client/activepause", {
            companyID: data.companyID,
            leadspeekID: data.leadspeekID,
            status: data.status,
            activeuser: data.activeuser,
            userID: data.userID,
            ip_user: data.ip_user,
            timezone: data.timezone,
            idSys: data.idSys,
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    RemoveLeadsPeekClient(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .put("/leadspeek/client/remove", {
            companyID: data.companyID,
            leadspeekID: data.leadspeekID,
            status: data.status,
            userID: data.userID
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    UpdateLeadsPeekClientLocal(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .put("/leadspeek/client/local/update", {
            companyID: data.companyID,
            leadspeekID: data.leadspeekID,
            //locatorzip: data.locatorzip,
            //locatordesc: data.locatordesc,
            //locatorkeyword: data.locatorkeyword,
            //locatorstate: data.locatorstate,
            locatorrequire: data.locatorrequire,
            //locatorcity: data.locatorcity,
            //sificampaign: data.sificampaign,
            //sifiorganizationid: data.sifiorganizationid,
            phoneenabled: data.phoneenabled,
            homeaddressenabled: data.homeaddressenabled,
            requireemailaddress: data.requireemailaddress,
            reidentificationtype: data.reidentificationtype
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    UpdateLeadsPeekClientLocator(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .put("/leadspeek/client/locator/update", {
            companyID: data.companyID,
            leadspeekID: data.leadspeekID,
            locatorzip: data.locatorzip,
            locatordesc: data.locatordesc,
            locatorkeyword: data.locatorkeyword,
            locatorkeywordcontextual: data.locatorkeywordcontextual,
            locatorstate: data.locatorstate,
            locatorrequire: data.locatorrequire,
            locatorcity: data.locatorcity,
            sificampaign: data.sificampaign,
            sifiorganizationid: data.sifiorganizationid,
            startdatecampaign: data.startdatecampaign,
            enddatecampaign: data.enddatecampaign,
            nationaltargeting: data.nationaltargeting,
            locationtarget: data.locationtarget,
            phoneenabled: data.phoneenabled,
            homeaddressenabled: data.homeaddressenabled,
            requireemailaddress: data.requireemailaddress,
            reidentificationtype: data.reidentificationtype
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    UpdateLeadsPeekClient(context, data) {
      return new Promise((resolve, reject) => {
        var _fieldupdate = "";
        var _valuefield = "";
        var _leadspeekType = "";

        if (
          data.leadspeekType != "" &&
          typeof data.leadspeekType != "undefined"
        ) {
          _leadspeekType = data.leadspeekType;
        }

        if (data.fieldupdate != "" && typeof data.fieldupdate != "undefined") {
          _fieldupdate = data.fieldupdate;
          _valuefield = data.valuefield;
        }
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .put("/leadspeek/client/update", {
            companyID: data.companyID,
            userID: data.userID,
            leadspeekID: data.leadspeekID,
            reportType: data.reportType,
            reportSentTo: data.reportSentTo,
            adminNotifyTo: data.adminNotifyTo,
            leadsAmountNotification: data.leadsAmountNotification,
            fieldupdate: _fieldupdate,
            valuefield: _valuefield,
            leadspeekType: _leadspeekType,
            companyGroupID: data.companyGroupID,
            clientOrganizationID: data.clientOrganizationID,
            clientCampaignID: data.clientCampaignID,
            clientHidePhone: data.clientHidePhone,
            campaignName: data.campaignName,
            urlCode: data.urlCode,
            urlCodeThankyou: data.urlCodeThankyou,
            gtminstalled: data.gtminstalled,

            locatorzip: data.locatorzip,
            locatordesc: data.locatordesc,
            locatorkeyword: data.locatorkeyword,
            locatorkeywordcontextual: data.locatorkeywordcontextual,
            locatorstate: data.locatorstate,
            locatorrequire: data.locatorrequire,
            locatorcity: data.locatorcity,
            externalcampaign: data.externalcampaign,
            externalorganizationid: data.externalorganizationid,
            startdatecampaign: data.startdatecampaign,
            enddatecampaign: data.enddatecampaign,
            oristartdatecampaign: data.oristartdatecampaign,
            orienddatecampaign: data.orienddatecampaign,
            nationaltargeting: data.nationaltargeting,
            locationtarget: data.locationtarget,
            phoneenabled: data.phoneenabled,
            homeaddressenabled: data.homeaddressenabled,
            requireemailaddress: data.requireemailaddress,
            reidentificationtype: data.reidentificationtype,
            applyreidentificationall: data.applyreidentificationall,
            timezone: data.timezone,
            listAdvanceInformationId: data.listAdvanceInformationId,
            listB2BInformationId: data.listB2BInformationId,
            campaign_information_type: data.campaign_information_type,
            campaign_information_type_local: data.campaignInformationTypeLocal,
            adminAddType: data.adminAddType,
            adminAddId: data.adminAddId,
            answers: data.answers,
            globalviewmode: data.globalviewmode
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    purgeSuppressionList(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
        .delete(
            "/leadspeek/suppressionlist/purge/" +
              data.paramID +
              "/" +
              data.campaignType
          )
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    ResendGoogleLink(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .post("/leadspeek/client/resendgooglelink", {
            companyID: data.companyID,
            userID: data.userID,
            leadspeekID: data.leadspeekID,
            reportSentTo: data.reportSentTo,
            adminNotifyTo: data.adminNotifyTo
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    CreateLeadsPeekClient(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .post("/leadspeek/client/create", {
            companyID: data.companyID,
            userID: data.userID,
            companyName: data.companyName,
            reportType: data.reportType,
            reportSentTo: data.reportSentTo,
            adminNotifyTo: data.adminNotifyTo,
            leadsAmountNotification: data.leadsAmountNotification,
            enableMinimumLimitLeads: data.enableMinimumLimitLeads,
            minimumLimitLeads: data.minimumLimitLeads,
            leadspeekType: data.leadspeekType,
            companyGroupID: data.companyGroupID,
            clientOrganizationID: data.clientOrganizationID,
            clientCampaignID: data.clientCampaignID,
            clientHidePhone: data.clientHidePhone,
            campaignName: data.campaignName,
            urlCode: data.urlCode,
            urlCodeThankyou: data.urlCodeThankyou,
            answers: data.answers,
            startdatecampaign: data.startdatecampaign,
            enddatecampaign: data.enddatecampaign,
            oristartdatecampaign: data.oristartdatecampaign,
            orienddatecampaign: data.orienddatecampaign,
            gtminstalled: data.gtminstalled,
            phoneenabled: data.phoneenabled,
            homeaddressenabled: data.homeaddressenabled,
            requireemailaddress: data.requireemailaddress,
            reidentificationtype: data.reidentificationtype,
            applyreidentificationall: data.applyreidentificationall,
            locationtarget: data.locationtarget,
            timezone: data.timezone,
            idSys: data.idSys,
            listAdvanceInformationId: data.listAdvanceInformationId,
            listB2BInformationId: data.listB2BInformationId,
            campaign_information_type: data.campaign_information_type,
            campaign_information_type_local: data.campaignInformationTypeLocal,
            globalviewmode: data.globalviewmode
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    GetLeadsPeekClientList(context, data) {
      return new Promise((resolve, reject) => {
        var _clientID = "";
        var _leadspeekType = "";
        var _groupCompanyID = "all/";
        var _sortby = "";
        var _order = "";
        var _searchkey = "";

        if (
          data.groupCompanyID != "" &&
          typeof data.groupCompanyID != "undefined"
        ) {
          _groupCompanyID = data.groupCompanyID + "/";
        }

        if (data.clientID != "" && typeof data.clientID != "undefined") {
          _clientID = "/" + data.clientID;
        }

        if (
          data.leadspeekType != "" &&
          typeof data.leadspeekType != "undefined"
        ) {
          _leadspeekType = _groupCompanyID + data.leadspeekType + "/";
        }

        if (typeof data.sortby != "undefined" && data.sortby != "") {
          if (_clientID == "") {
            _sortby = "/0/" + data.sortby;
          } else {
            _sortby = "/" + data.sortby;
          }
        }

        if (typeof data.order != "undefined" && data.order != "") {
          if (_sortby != "") {
            _order = "/" + data.order;
          }
        }

        if (typeof data.searchkey != "undefined" && data.searchkey != "") {
          if (_sortby == "" && _clientID == "") {
            _searchkey = "/0/0/0/" + data.searchkey;
          } else {
            _searchkey = "/" + data.searchkey;
          }
        }
      let param =   {
         
          PerPage: data.perPage,
          view: data.view,
          CampaignStatus: data.campaignStatus
        }
        if(data.page){
          param.Page = data.page
        }
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .get(
            "/leadspeek/client/" +
              _leadspeekType +
              data.companyID +
              _clientID +
              _sortby +
              _order +
              _searchkey,
            {
              params:param
            }
          )
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },

    disconectGoogleSheet(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .get("/leadspeek/googlespreadsheet/revoke/" + data.companyID)
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    savePlanPackage(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .put("/configuration/setting/package", {
            CompanyID: data.CompanyID,
            packageID: data.packageID
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    getRootRevenue(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .get(`/configuration/root-revenue/${data.startDate}/${data.endDate}`)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    getReportAnalytics(context, data) {
      return new Promise((resolve, reject) => {
        var _companyid = "";
        var _campaignid = "";

        if (data.companyid != "" && typeof data.companyid != "undefined") {
          _companyid = "/" + data.companyid;
        }

        if (
          data.campaignid != "" &&
          typeof data.campaignid != "undefined" &&
          _companyid != ""
        ) {
          _campaignid = "/" + data.campaignid;
        }

        if (_companyid == "" && _campaignid == "" && data.companyrootid != "") {
          _companyid = "/0/0/" + data.companyrootid;
        }

        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .get(
            "/configuration/report-analytics/" +
              data.startDate +
              "/" +
              data.endDate +
              _companyid +
              _campaignid
          )
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    getPixelLeadRecord(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        
        let url = `/configuration/pixel-lead-record/${data.startDate}/${data.endDate}`;
        if (data.companyrootid && data.companyrootid !== "") {
          url += `/${data.companyrootid}`;
        }

        axios.get(`${url}`)
             .then(response => {
              resolve(response.data);
             })
             .catch(error => {
              reject(error);
             })
      });
    },
    setAgencyExcludeMinimumSpend(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .put("/configuration/setting/exclude-include-mininum-spend", {
            CompanyID: data.CompanyID,
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },

    setAgencyOnboardingCharge(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .put(`/configuration/onboarding/set`, {
            CompanyID: data.CompanyID,
            amount: data.amount,
            enable_coupon: data.enable_coupon,
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    getOnboardAgencySettings(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .get(`/configuration/onboarding/get`, {
            params: {
              companyID: data.companyID,
              companyRootID: data.companyRootID,
              settingname: data.settingname  
            }
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    createConnectedAccountLink(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .post("/general/get-connected-account-link", {
            connectid: data.connectid,
            refreshurl: data.refreshurl,
            returnurl: data.returnurl,
            idsys: data.idsys
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },

    createExistingConnectedAccountLink(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .post("/general/get-existing-connected-account-link", {
            company_root_id: data.company_root_id,
            company_id: data.company_id,
            email: data.email,
            user_id: data.user_id,
            user_type: data.user_type,
            subdomain: data.subdomain,
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    createConnectedAccount(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .post("/general/create-connected-account", {
            companyID: data.companyID,
            companyname: data.companyname,
            companyphone: data.companyphone,
            companyaddress: data.companyaddress,
            companycity: data.companycity,
            companystate: data.companystate,
            companyzip: data.companyzip,
            companycountry: data.companycountry,
            companyemail: data.companyemail,
            weburl: data.weburl,
            idsys: data.idsys
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            //console.log(error);
            reject(error.response.data.message);
          });
      });
    },
    createSalesConnectedAccount(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .post("/general/create-sales-connected-account", {
            userID: data.usrID,
            idsys: data.idsys
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            //console.log(error);
            reject(error.response.data.message);
          });
      });
    },
    checkConnectedAccount(context, data) {
      let param = data.companyID && data.idsys ?  data.companyID + "/" + data.idsys : data.companyID;
      // console.log(param); 
      // exit;
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .get(
            "/general/check-connected-account/" + param
          )
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    checkSalesConnectedAccount(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .get(
            "/general/check-sales-connected-account/" +
              data.usrID +
              "/" +
              data.idsys
          )
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    checkGoogleConnectSheet(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .get("/leadspeek/googlespreadsheet/check-connect/" + data.companyID)
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    resetpaymentconnection(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .delete(
            "/general/reset-payment-connection/" +
              data.companyID +
              "/" +
              data.typeConnection
          )
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    /** LEADSPEEK */

    /** CONFIGURATION APP */
    updateCustomDomain(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .put("/configuration/update-custom-domain", {
            companyID: data.companyID,
            DownlineDomain: data.DownlineDomain,
            whitelabelling: data.whitelabelling
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    getCampaignResource(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .get(
            "/leadspeek/getcampaignresource/" +
              data.organizationID +
              "/" +
              data.campaignID
          )
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    getDomainorSubInfo(context, data) {
      return new Promise((resolve, reject) => {
        var hostclientID = "";
        if (typeof data.hostID != "undefined" && data.hostID != "") {
          hostclientID = "/" + data.hostID;
        }
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .get("/domainsubdomain/" + data.domainorsub + hostclientID, {
            params: {
              agency_company_id: data.agencyCompanyId || null,
            },
          })
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    }, 
    getUserCampaigns(context, data) {
      return new Promise((resolve, reject) => {        
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .post(
            "/configuration/user/show-campaigns"
          , { 
              companyID: data.companyID,
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    getUsers(context, data) {
      return new Promise((resolve, reject) => {        
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .post(
            "/configuration/user/show-user"
          , { 
              companyID: data.companyID,
              user_type: data.userType,
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    getUserLogs(context, data) {
      return new Promise((resolve, reject) => {        
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .post(
            "/configuration/user/log-user"
          , { 
              companyID: data.companyID,
              action: data.action,
              user_type: data.userType,
              user_id: data.userID,
              page: data.page,
              leadspeek_api_id: data.campaignID,
              log_date_range: data.logDateRange,
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    getUserLogsCategory(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .post(
            "/configuration/user/log-category"
          ,)
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    getGeneralSetting(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .get(
            "/configuration/setting/" + data.companyID + "/" + data.settingname
          , {
            params: {
              idSys: data.idSys,
              pk: data.pk,
            }
          })
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    getCityStateList(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .get("/general/state/" + data.citystate + "/cities")
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    getStateList(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .get("/general/state")
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    getSalesList(context, data) {
      return new Promise((resolve, reject) => {
        var _companyID = "";

        if (data.companyID != "") {
          _companyID = "/" + data.companyID;
        }

        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .get("/configuration/sales/list" + _companyID)
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    getRootList(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .get("/configuration/root/list")
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    setSalesPerson(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .put("/configuration/sales", {
            companyID: data.companyID,
            salesRep: data.salesRep,
            salesAE: data.salesAE,
            salesRef: data.salesRef
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    ClientModuleCost(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .put("/configuration/user/costmodule", {
            companyID: data.companyID,
            ClientID: data.ClientID,
            ModuleName: data.ModuleName,
            CostSet: data.CostSet,
            CostSetAdvanced: data.CostSetAdvanced,
            CostSetB2b: data.CostSetB2b,
            CostMonth: data.CostMonth,
            CostMaxLead: data.CostMaxLead,
            LimitLead: data.LimitLead,
            enableMinimumLimitLeads: data.enableMinimumLimitLeads,
            minimumLimitLeads: data.minimumLimitLeads,
            LimitLeadFreq: data.LimitLeadFreq,
            LimitLeadStart: data.LimitLeadStart,
            LimitLeadEnd: data.LimitLeadEnd,
            PaymentTerm: data.PaymentTerm,
            contiDurationSelection: data.contiDurationSelection,
            topupoptions: data.topupoptions,
            leadsbuy: data.leadsbuy,
            PlatformFee: data.PlatformFee,
            LeadspeekApiId: data.LeadspeekApiId,
            idUser: data.idUser,
            ipAddress: data.ipAddress,
            idSys: data.idSys
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    RemoveRoleModule(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .delete(
            "/configuration/role-module/remove/" +
              data.companyID +
              "/" +
              data.roleID
          )
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    addUpdateRole(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .put("/configuration/role-module/addupdate", {
            companyID: data.companyID,
            roleID: data.roleID,
            roleName: data.roleName,
            roleIcon: data.roleIcon,
            roledata: data.roledata
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    GetRoleList(context, data) {
      return new Promise((resolve, reject) => {
        var _companyID = "";
        var _getType = "";
        var _roleID = "";
        var _usrID = "";

        if (data.getType != "") {
          _getType = data.getType;
        }
        if (data.companyID != "" && data.getType != "") {
          _companyID = "/" + data.companyID;
        }
        if (data.companyID != "" && data.getType != "" && data.roleID != "") {
          _roleID = "/" + data.roleID;
        }

        if (
          data.companyID != "" &&
          data.getType != "" &&
          data.roleID != "" &&
          data.usrID != ""
        ) {
          _usrID = "/" + data.usrID;
        }

        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .get(
            "/configuration/role-module/" +
              _getType +
              _companyID +
              _roleID +
              _usrID
          )
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    RemoveClient(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .delete(
            "/configuration/user/remove/" + data.companyID + "/" + data.userID,
            {
              params: {
                params: data.params,
              }
            }
          )
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    UpdateClient(context, data) {
      var _ClientPass = "";
      if (data.ClientPass != "") {
        _ClientPass = data.ClientPass;
      }
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .put("/configuration/user/update", {
            companyID: data.companyID,
            ClientID: data.ClientID,
            ClientCompanyName: data.ClientCompanyName,
            ClientFullName: data.ClientFullName,
            ClientEmail: data.ClientEmail,
            ClientPhone: data.ClientPhone,
            ClientPhoneCountryCode: data.ClientPhoneCountryCode,
            ClientPhoneCountryCallingCode: data.ClientPhoneCountryCallingCode,
            ClientPass: _ClientPass,
            ClientRole: data.ClientRole,
            ClientDomain: data.ClientDomain,
            ClientWhiteLabeling: data.ClientWhiteLabeling,
            ApiMode: data.ApiMode,
            DownlineDomain: data.DownlineDomain,
            DownlineSubDomain: data.DownlineSubDomain,
            DownlineOrganizationID: data.DownlineOrganizationID,
            defaultAdmin: data.defaultAdmin,
            customercare: data.customercare,
            adminGetNotification: data.adminGetNotification,
            action: data.action,
            disabledreceivedemail: data.disabledreceivedemail,
            disabledaddcampaign: data.disabledaddcampaign,
            selectedterms: data.selectedterms,
            selectedmodules: data.selectedmodules,
            idsys: data.idsys,
            permission_active: data.permission_active,
            user_permissions: data.user_permissions,
            enablephonenumber: data.enablephonenumber,
            editorspreadsheet: data.editorspreadsheet,
            planMinSpendId: data.planMinSpendId,
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error.response);
          });
      });
    },
    manualBillSettlement(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .put(
            "/general/manual-bill-settlement", {
              userID: data.userID,
          })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    testsmtp(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .post("/configuration/user/testsmtp", {
            companyID: data.companyID,
            emailsent: data.emailsent
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    ResendInvitation(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .post("/configuration/user/resendinvitation", {
            ClientID: data.ClientID
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    CreateClient(context, data) {
      var _ClientPass = "";
      if (data.ClientPass != "") {
        _ClientPass = data.ClientPass;
      }
      let _selectedModules = '';
      if (data.selectedModulesCreate) {
        _selectedModules = data.selectedModulesCreate
      }else if (data.selectedmodules) {
        _selectedModules = data.selectedmodules
      }
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .post("/configuration/user/create", {
            companyID: data.companyID,
            userType: data.userType,
            ClientCompanyName: data.ClientCompanyName,
            ClientFullName: data.ClientFullName,
            ClientEmail: data.ClientEmail,
            ClientPhone: data.ClientPhone,
            ClientPhoneCountryCode: data.ClientPhoneCountryCode,
            ClientPhoneCountryCallingCode: data.ClientPhoneCountryCallingCode,
            ClientPass: _ClientPass,
            ClientRole: data.ClientRole,
            ClientDomain: data.ClientDomain,
            ClientWhiteLabeling: data.ClientWhiteLabeling,
            ApiMode: data.ApiMode,
            DownlineDomain: data.DownlineDomain,
            DownlineSubDomain: data.DownlineSubDomain,
            DownlineOrganizationID: data.DownlineOrganizationID,
            defaultAdmin: data.defaultAdmin,
            customercare: data.customercare,
            adminGetNotification: data.adminGetNotification,
            disabledreceivedemail: data.disabledreceivedemail,
            disabledaddcampaign: data.disabledaddcampaign,
            idsys: data.idsys,
            salesRep: data.salesRep,
            salesAE: data.salesAE,
            salesRef: data.salesRef,
            selectedterms: data.selectedterms,
            selectedmodules: _selectedModules,
            twoFactorAuth: data.twoFactorAuth,
            permission_active: data.permission_active,
            user_permissions: data.user_permissions,
            TokenId: data.TokenId || '',
            Amount: data.Amount || '',
            enablephonenumber: data.enablephonenumber,
            editorspreadsheet: data.editorspreadsheet,
            adminAddToAllCampaign: data.adminAddToAllCampaign,
            location_id: data.location_id, // hanya untuk client
            custom_menu_name: data.custom_menu_name, // hanya untuk client
            ip_login: data.ip_login,
            planMinSpendId: data.planMinSpendId,
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    GetSalesDownlineList(context, data) {
      var _searchkey = "";
      var _sortby = "";
      var _order = "";

      if (typeof data.sortby != "undefined" && data.sortby != "") {
        _sortby = "/" + data.sortby;
      }

      if (typeof data.order != "undefined" && data.order != "") {
        if (_sortby != "") {
          _order = "/" + data.order;
        }
      }

      if (typeof data.searchkey != "undefined" && data.searchkey != "") {
        if (_sortby == "") {
          _searchkey = "/0/0/" + data.searchkey;
        } else {
          _searchkey = "/" + data.searchkey;
        }
      }

      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .get(
            "/configuration/sales-downline/" +
              data.companyID +
              "/" +
              data.usrID +
              "/" +
              data.idsys +
              _sortby +
              _order +
              _searchkey,
            {
              params: {
                Page: data.page,
                PerPage: data.perPage
              }
            }
          )
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    GetClientList(context, data) {
      return new Promise((resolve, reject) => {
        var _companyID = "";
        var _idSys = "";
        var _userType = "";
        var _groupCompanyID = "/all";
        var _sortby = "";
        var _order = "";

        var _searchkey = "";

        if (
          data.groupCompanyID != "" &&
          typeof data.groupCompanyID != "undefined"
        ) {
          _groupCompanyID = "/" + data.groupCompanyID;
        }

        if (data.companyID != "") {
          _companyID = data.companyID;
        }
        if (data.idsys != "") {
          _idSys = "/" + data.idsys;
        }

        if (data.companyID != "" && data.userType != "") {
          _userType = "/" + data.userType;
        }

        if (
          data.userType != "" &&
          data.userModule != "" &&
          typeof data.userModule != "undefined"
        ) {
          _userType = _userType + "/" + data.userModule;
        }

        if (typeof data.sortby != "undefined" && data.sortby != "") {
          _sortby = "/" + data.sortby;
        }

        if (typeof data.order != "undefined" && data.order != "") {
          if (_sortby != "") {
            _order = "/" + data.order;
          }
        }

        if (typeof data.searchkey != "undefined" && data.searchkey != "") {
          if (_sortby == "") {
            _searchkey = "/0/0/" + data.searchkey;
          } else {
            _searchkey = "/" + data.searchkey;
          }
        }

        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .get(
            "/configuration/user/" +
              _companyID +
              _groupCompanyID +
              _idSys +
              _userType +
              _sortby +
              _order +
              _searchkey,
            {
              params: {
                Page: data.page,
                PerPage: data.perPage,
                CardStatus: data.cardStatus,
                CampaignStatus: data.campaignStatus,
                Filters: data.filters,
                Exclude: data.exclude,
                inAgencyList: data.inAgencyList
              }
            }
          )
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    GetUnderPerformCampaigns(context, data){
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .get("/configuration/get-under-perform-campaigns", {
            params: {
              campaign_ids: data.campaignIds,
              selected_date: data.selectedDate,
            }
          })
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });

    },
    GetAgencyList(context, data) {
      return new Promise((resolve, reject) => {
        var _companyID = "";
        var _userType = "";
        var _groupCompanyID = "/all";
        var _sortby = "";
        var _order = "";
        var _searchkey = "";

        if (
          data.groupCompanyID != "" &&
          typeof data.groupCompanyID != "undefined"
        ) {
          _groupCompanyID = "/" + data.groupCompanyID;
        }

        if (data.companyID != "" && data.userType != "") {
          _userType = "/" + data.userType;
        }

        if (typeof data.sortby != "undefined" && data.sortby != "") {
          _sortby = "/" + data.sortby;
        }

        if (typeof data.order != "undefined" && data.order != "") {
          if (_sortby != "") {
            _order = "/" + data.order;
          }
        }

        if (typeof data.searchkey != "undefined" && data.searchkey != "") {
          if (_sortby == "") {
            _searchkey = "/created_at/descending/" + data.searchkey;
          } else {
            _searchkey = "/" + data.searchkey;
          }
        }

        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .get(
            "/configuration/agencies-report" +
              _groupCompanyID +
              _sortby +
              _order +
              _searchkey,
            {
              params: {
                Page: data.page,
                PerPage: data.perPage,
                CardStatus: data.cardStatus,
                CampaignStatus: data.campaignStatus,
                SelectedDate: data.selectedDate,
                OpenApiStatus: data.openApiStatus,
              }
            }
          )
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },

    testEmail(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .post("/configuration/setting/test-email", {
            fromAddress: data.fromAddress,
            fromName: data.fromName,
            fromReplyto: data.fromReplyto,
            subject: data.subject,
            content: data.content,
            testEmailAddress: data.testEmailAddress,
            companyID: data.companyID,
            companyParentID: data.companyParentID,
            userType: data.userType
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },

    updateGeneralSetting(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .put("/configuration/setting", {
            companyID: data.companyID,
            actionType: data.actionType,
            sidebarcolor: data.sidebarcolor,
            templatecolor: data.templatecolor,
            boxcolor: data.boxcolor,
            textcolor: data.textcolor,
            linkcolor: data.linkcolor,
            fonttheme: data.fonttheme,
            paymenttermDefault: data.paymenttermDefault,
            comsetname: data.comsetname,
            comsetval: data.comsetval
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },

    retryDomainSSL(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .put("/configuration/retrydomainssl", {
            companyID: data.companyID,
            domain: data.domain
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log('Domain SSL retry error:', error);
            reject(error);
          });
      });
    },

    updateDefaultSubdomain(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .put("/configuration/subdomain", {
            companyID: data.companyID,
            subdomain: data.subdomain,
            idsys: data.idsys
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    /** CONFIGURATION APP */

    /** MARKETING SIMPLI.FI */
    DeleteOrganization(context, data) {
      return new Promise((resolve, reject) => {
        axios
          .delete("/marketing/deleteorganization/" + data.OrganizationID)
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    GetOrganizationList(context, data) {
      return new Promise((resolve, reject) => {
        var _organizationID = "";
        var _requestType = "";

        if (data.OrganizationID != "") {
          _organizationID = data.OrganizationID;
        }
        if (data.OrganizationID != "" && data.RequestType != "") {
          _requestType = "/" + data.RequestType;
        }

        axios
          .get("/marketing/getorganization/" + _organizationID + _requestType)
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response.data.organizations);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    CreateOrganization(context, data) {
      return new Promise((resolve, reject) => {
        axios
          .post("/marketing/createorganization", {
            OrganizationName: data.OrganizationName,
            ParentID: data.ParentID,
            CustomID: data.CustomID
          })
          .then(response => {
            resolve(response.data.organizations);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    /** MARKETING SIMPLI.FI */
    GetBannerList(context, data) {
      return new Promise((resolve, reject) => {
        axios
          .post("/banner/show", {
            bannertype: data.bannertype,
            //bannersethash: data.bannersethash,
            username: this.state.userData.email,
            type: data.type
          })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error.response.data.errors);
            //resolve('failed');
          });
      });
    },
    StartBannerCreate(context, data) {
      return new Promise((resolve, reject) => {
        axios
          .post("/banner/startbannercreate", {
            bannertype: data.bannertype,
            banneranimated: data.banneranimated,
            username: this.state.userData.email,
            name: this.state.userData.name
          })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error.response.data.errors);
            //resolve('failed');
          });
      });
    },
    forgetPass(context, data) {
      return new Promise((resolve, reject) => {
        axios
          .post("/forgetpass", {
            username: data.username,
            gtoken: data.gtoken,
            ownedcompanyid: data.ownedcompanyid,
            companyrootid: data.companyrootid
          })
          .then(response => {
            resolve("success");
          })
          .catch(error => {
             let message = 'Something went wrong. Please try again later.';
  
              if (
                error &&
                error.response &&
                error.response.data &&
                error.response.data.message
              ) {
                message = error.response.data.message;
              }

            reject({ message: message });
            //resolve('failed');
          });
      });
    },
    register(context, data) {
      return new Promise((resolve, reject) => {
        var _companyname = "";
        var _phonenum = "";
        var _userType = "client";
        var _refcode = "";

        if (data.companyname != "") {
          _companyname = data.companyname;
        }

        if (data.phonenum != "") {
          _phonenum = data.phonenum;
        }

        if (data.userType != "") {
          _userType = data.userType;
        }

        if (data.refcode != "") {
          _refcode = data.refcode;
        }

        axios
          .post("/register", {
            companyname: _companyname,
            name: data.name,
            email: data.email,
            phonenum: _phonenum,
            password: data.password,
            gtoken: data.gtoken,
            userType: data.userType,
            domainName: data.domainName,
            ownedcompanyid: data.ownedcompanyid,
            idsys: data.idsys,
            refcode: _refcode,
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            /*console.log(error.response.data.errors.email);
            console.log('errorType', typeof error);
            console.log('error', Object.assign({}, error));
            console.log('getOwnPropertyNames', Object.getOwnPropertyNames(error));
            console.log('stackProperty', Object.getOwnPropertyDescriptor(error, 'stack'));
            console.log('messageProperty', Object.getOwnPropertyDescriptor(error, 'message'));
            console.log('stackEnumerable', error.propertyIsEnumerable('stack'));
            console.log('messageEnumerable', error.propertyIsEnumerable('message'));
            */
            //console.log(error.response.data.errors.email[0]);
            //console.log(error.response.data.errors.captcha[0]);

            /*Object.keys(error.response.data.errors).forEach(key => {
            console.log(error.response.data.errors[key][0]);
           })*/
            //console.log(error.response.data.message);
            reject(error.response.data.errors);
            //resolve('failed');
          });
      });
    },
    destroyToken(context) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;

      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          axios
            .post("/logout")
            .then(response => {
              localStorage.removeItem("access_token");
              localStorage.removeItem("refresh_token");
              localStorage.removeItem("expires_in");
              localStorage.removeItem("userData");
              localStorage.removeItem("userDataOri");
              localStorage.removeItem("userRole");
              localStorage.removeItem("clientIP");
              context.commit("destroyToken");
              resolve(response);
              // console.log(response);
              // context.commit('addTodo', response.data)
            })
            .catch(error => {
              localStorage.removeItem("access_token");
              localStorage.removeItem("refresh_token");
              localStorage.removeItem("expires_in");
              localStorage.removeItem("userData");
              localStorage.removeItem("userDataOri");
              localStorage.removeItem("userRole");
              localStorage.removeItem("clientIP");
              context.commit("destroyToken");
              reject(error);
            });
        });
      }
    },

    putTokenSocial(context, credentials) {
      return new Promise((resolve, reject) => {
        const token = credentials.acctoken;

        localStorage.setItem("access_token", token);
        context.commit("retrieveToken", token);
        resolve("success");
      });
    },

    retrieveToken(context, credentials) {
      return new Promise((resolve, reject) => {
        axios
          .post("/login", {
            username: credentials.username,
            password: credentials.password,
            gtoken: credentials.gtoken,
            domainName: credentials.domainName,
            ownedcompanyid: credentials.ownedcompanyid,
            companyrootid: credentials.companyrootid
          })
          .then(response => {
            const token = response.data.access_token;
            const refreshToken = response.data.refresh_token;
            const expiresIn = response.data.expires_in;

            localStorage.setItem("access_token", token);
            localStorage.setItem("refresh_token", refreshToken);
            localStorage.setItem("expires_in", expiresIn);
            axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

            // setupAutoRefresh(); 
            
            context.commit("retrieveToken", token);
            resolve(response);
            //console.log(response);
            // context.commit('addTodo', response.data)
          })
          .catch(error => {
            //console.log(error.response.data)
            reject(error);
            //resolve('loginfailed')
          });
      });
    },

    ssoValidationToken(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + data.token;
        axios.post('/v1/developer/sso/validation', {
          subdomain: data.subdomain,
          currentUserID: data.currentUserID
        })
        .then(response => {
          const token = response.data.access_token;

          if(response.data.action == 'replace_user') {
            localStorage.removeItem("userData");
            localStorage.removeItem("userDataOri");
            localStorage.removeItem("userRole");
            localStorage.removeItem("clientIP");
            context.commit("destroyToken");
          }

          localStorage.setItem("access_token", token);
          context.commit("retrieveToken", token);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
      });
    },

    retrieveAutomComplete(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get("/" + data.category + "/autocomplete/" + data.searchtext)
          .then(response => {
            context.commit("putResultData", response.data);
            resolve("success");
          })
          .catch(error => {
            resolve("failed");
          });
      });
    },

    checkUserSetupComplete(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get("/user/checksetupcomplete/" + data.usrID)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },

    userSetupComplete(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .put("/leadspeek/user/setupcomplete", {
            usrID: data.usrID,
            statuscomplete: data.statuscomplete,
            answers: data.answers,
            companyGroupID: data.companyGroupID,
            startdatecampaign: data.startdatecampaign,
            enddatecampaign: data.enddatecampaign,
            oristartdatecampaign: data.oristartdatecampaign,
            orienddatecampaign: data.orienddatecampaign,
            phoneenabled: data.phoneenabled,
            homeaddressenabled: data.homeaddressenabled,
            requireemailaddress: data.requireemailaddress,
            phoneenabledsiteid: data.phoneenabledsiteid,
            homeaddressenabledsiteid: data.homeaddressenabledsiteid,
            requireemailaddresssiteid: data.requireemailaddresssiteid,
            timezone: data.timezone
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    switchUserData(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get("/user/" + data.usrID)
          .then(response => {
            const switchDataUser = response.data;
            const masterUser = context.getters.userData;
            // console.log({switchDataUser, masterUser});
    
            /**
             * kondisi
             * 1. root view as agency, lalu view as lagi sebagai client (new)
             */
            if('userDataOri' in localStorage) 
            {
              const companyGroupSelected = localStorage.getItem("companyGroupSelected");
              const subdomainAgency = localStorage.getItem("subdomainAgency");
              const rootcomp = localStorage.getItem("rootcomp") === "true";

              if (switchDataUser["user_type"] == "client") {
                localStorage.removeItem("companyGroupSelected");
                localStorage.setItem("companyGroupSelected", switchDataUser["id"]);
              } else {
                localStorage.removeItem("companyGroupSelected");
                localStorage.setItem("companyGroupSelected", "");
              }

              switchDataUser["user_type_ori"] = masterUser["user_type_ori"];
              masterUser['agencyLocalStorageBackup'] = { companyGroupSelected, subdomainAgency, rootcomp };
              const envryptedObjectOri = CryptoJS.AES.encrypt(JSON.stringify(masterUser), "3ZY@l9qxdwL6");

              localStorage.removeItem("userData");
              localStorage.removeItem("userDataAgency");
              localStorage.setItem("userDataAgency", envryptedObjectOri);

              switchDataUser.user_permissions_view_mode = null
              if (masterUser.user_permissions != null) {
                switchDataUser.user_permissions_view_mode = JSON.parse(masterUser.user_permissions)
              }
  
              if (masterUser.rootcomp) { // View mode root EMM not encrypt
                switchDataUser.isViewMode = true
              }

              localStorage.removeItem('subdomainAgency');
              localStorage.removeItem('rootcomp');
            }
            /**
             * kondisi
             * 1. root view as agency (old)
             * 2. root view as client (old)
             * 3. agency view as client (new)
             */
            else
            {
              if (switchDataUser["user_type"] == "client") {
                localStorage.removeItem("companyGroupSelected");
                localStorage.setItem("companyGroupSelected", switchDataUser["id"]);
              } else {
                localStorage.removeItem("companyGroupSelected");
                localStorage.setItem("companyGroupSelected", "");
              }
  
              switchDataUser["user_type_ori"] = masterUser["user_type"];
              const envryptedObjectOri = CryptoJS.AES.encrypt(JSON.stringify(masterUser), "3ZY@l9qxdwL6");
              //var decrypt =JSON.parse(CryptoJS.AES.decrypt(envryptedObjectOri,'UNEMM').toString(CryptoJS.enc.Utf8));
  
              localStorage.removeItem("userData");
              localStorage.removeItem("userDataOri");
              localStorage.setItem("userDataOri", envryptedObjectOri);
  
              switchDataUser.user_permissions_view_mode = null
              if (masterUser.user_permissions != null) {
                switchDataUser.user_permissions_view_mode = JSON.parse(masterUser.user_permissions)
              }
  
              if (masterUser.systemuser && masterUser.rootcomp) { // View mode root EMM not encrypt
                switchDataUser.isViewMode = true
              }
            }
            
            context.commit("retrieveUser", switchDataUser);
            resolve("success");
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    retrieveUserData(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        var userID = "";
        if (typeof data.usrID != "undefined" && data.usrID != "") {
          userID = "/" + data.usrID;
        }
        axios
          .get("/user" + userID)
          .then(response => {
            const dataUser = response.data;
            context.commit("retrieveUser", dataUser);
            //resolve(response)
            //console.log(response.data);
            // context.commit('addTodo', response.data)
            resolve("success");
          })
          .catch(error => {
            //localStorage.removeItem('access_token')
            //context.commit('destroyToken')
            //reject(error)
            resolve("failed");
          });
      });
    },
    setUserData(context, data) {
      context.commit("retrieveUser", data.user);
    },
    updatePass(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .post("/user/resetpassword", {
            usrID: data.usrID,
            newpassword: data.newpassword,
            currpassword: data.currpassword
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    docDownloadAuth(context, data) {
      return new Promise((resolve, reject) => {
        axios
          .post("/docauth", {
            pwd: data.password,
            urldata: data.dataurl
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    saveProfileStep1(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        let formData = new FormData();
        formData.append("name", data.name);
        formData.append("email", data.email);
        formData.append("phone", data.phone);
        formData.append("phoneCountryCode", data.phoneCountryCode);
        formData.append("phoneCountryDialCode", data.phoneCountryDialCode);
        formData.append("address", data.address);
        formData.append("city", data.city);
        formData.append("country", data.country);
        formData.append("zip", data.zip);
        formData.append("state", data.state);
        formData.append("pict", data.pict);
        formData.append("currpict", data.currpict);
        formData.append("profilestep", data.profilestep);
        formData.append("newpass", data.newpass);
        formData.append("renewpass", data.renewpass);
        formData.append("id", data.id);
        formData.append("idsys", data.idsys);

        axios
          .post("/user/update", formData)
          .then(response => {
            if (response.data.result == 'error_email') {
              resolve(response.data.message);
            } else {
              const updatedData = {};
              if (response.data.image_url != "") {
                updatedData.profile_pict = response.data.image_url;
              } else if (response.data.picexist == "") {
                updatedData.profile_pict = "";
              }
              updatedData.name = data.name;
              updatedData.email = data.email;
              updatedData.phonenum = data.phone;
              updatedData.phone_country_code = data.phoneCountryCode;
              updatedData.phone_country_calling_code = data.phoneCountryDialCode;
              updatedData.address = data.address;
              updatedData.city = data.city;
              updatedData.zip = data.zip;
              updatedData.country_code = data.country;
              updatedData.state_code = data.state;
  
              context.commit('updateUserData', updatedData)
              //console.log(response.data.image_url);
              //resolve(response)
              //console.log(response.data);
              // context.commit('addTodo', response.data)
              resolve("success");
            }
            
          })
          .catch(error => {
            //localStorage.removeItem('access_token')
            //context.commit('destroyToken')
            //reject(error)
            resolve("failed");
          });
      });
    },

    saveProfileStep2(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        let formData = new FormData();

        if (data.id != "" && data.id != "" && typeof data.id != "undefined") {
          formData.append("id", data.id);
        }

        formData.append("industryID", data.industryID);
        formData.append("industryName", data.industryName);
        formData.append("companyID", data.companyID);
        formData.append("companyName", data.companyName);
        formData.append("companyphone", data.companyphone);
        formData.append(
          "companyphoneCountryCode",
          data.companyphoneCountryCode
        );
        formData.append(
          "companyPhoneCountryCallingCode",
          data.companyPhoneCountryCallingCode
        );
        formData.append("companyemail", data.companyemail);

        formData.append("companyaddress", data.companyaddress);
        formData.append("companycity", data.companycity);
        formData.append("companyzip", data.companyzip);
        formData.append("companystate", data.companystate);
        formData.append("companycountry", data.companycountry);
        formData.append("franchize", data.franchize);
        formData.append("franchizedirector", data.franchizedirector);

        formData.append("directorfn", data.directorfn);
        formData.append("directorln", data.directorln);
        formData.append("directoremail", data.directoremail);
        formData.append("directorphone", data.directorphone);

        formData.append("officemanager", data.officemanager);
        formData.append("managerfn", data.managerfn);
        formData.append("managerln", data.managerln);
        formData.append("manageremail", data.manageremail);
        formData.append("managerphone", data.managerphone);

        formData.append("team", data.team);
        formData.append("teammanager", data.teammanager);
        formData.append("teamfn", data.teamfn);
        formData.append("teamln", data.teamln);
        formData.append("teamphone", data.teamphone);
        formData.append("teamemail", data.teamemail);

        formData.append("pict", data.pict);
        formData.append("currpict", data.currpict);
        formData.append("profilestep", data.profilestep);

        formData.append("DownlineSubDomain", data.DownlineSubDomain);
        formData.append("idsys", data.idsys);

        axios
          .post("/user/update", formData)
          .then(response => {
            const updatedData = {}
            if (response.data.image_url != "") {
              updatedData.company_logo = response.data.image_url;
            } else if (response.data.picexist == "") {
              updatedData.company_logo = "";
            }
            updatedData.industry_id = response.data.industryID;
            updatedData.company_id = response.data.companyID;

            updatedData.industry_name = data.industryName;
            updatedData.company_name = data.companyName;
            updatedData.company_phone = data.companyphone;
            updatedData.company_phone_country_code =
              data.companyphoneCountryCode;
            updatedData.company_phone_country_calling_code =
              data.companyPhoneCountryCallingCode;
            updatedData.company_email = data.companyemail;
            updatedData.company_address = data.companyaddress;

            updatedData.company_city = data.companycity;
            updatedData.company_zip = data.companyzip;
            updatedData.company_state_code = data.companystate;
            updatedData.company_country_code = data.companycountry;

            updatedData.franchize = data.franchize;
            updatedData.franchizedirector = data.franchizedirector;
            updatedData.directorfn = data.directorfn;
            updatedData.directorln = data.directorln;
            updatedData.directoremail = data.directoremail;
            updatedData.directorphone = data.directorphone;

            updatedData.officemanager = data.officemanager;
            updatedData.managerfn = data.managerfn;
            updatedData.managerln = data.managerln;
            updatedData.manageremail = data.manageremail;
            updatedData.managerphone = data.managerphone;

            updatedData.team = data.team;
            updatedData.teammanager = data.teammanager;

            updatedData.teamfn = data.teamfn;
            updatedData.teamln = data.teamln;
            updatedData.teamemail = data.teamemail;
            updatedData.teamphone = data.teamphone;
            context.commit('updateUserData', updatedData)

            resolve(response.data.result);
          })
          .catch(error => {
            //localStorage.removeItem('access_token')
            //context.commit('destroyToken')
            //reject(error)
            resolve("failed");
          });
      });
    },

    getUserData(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        var userID = "";
        if (typeof data.usrID != "undefined" && data.usrID != "") {
          userID = "/" + data.usrID;
        }
        axios
          .get("/user" + userID)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getAgencyWhitelabelDomain(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        var company_id = "";
        if (typeof data.companyID != "undefined" && data.companyID != "") {
          company_id = "/" + data.companyID;
        }
        axios
          .get("/company/whitelabel-domain" + company_id)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Integrations api
    generateGHLv2AuthUrl(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.post('/gohighlevelv2/generateauthurl', {
          company_id: data.company_id,
          subdomain_url: data.subdomain_url,
          enable_sendgrid: data.enable_sendgrid,
          custom_fields_general: data.custom_fields_general,
          custom_fields_b2b: data.custom_fields_b2b,
          custom_fields_advance: data.custom_fields_advance,
          custom_menu_name: data.custom_menu_name,
          user_ip: data.user_ip,
          is_in_iframe: data.is_in_iframe
        })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error);
        })
      });
    },
    generateSendJimAuthUrl(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.post('/sendjim/generateauthurl', {
          company_id: data.company_id,
          subdomain_url: data.subdomain_url,
          user_ip: data.user_ip,
          client_id: data.client_id,
          client_secret: data.client_secret,
        })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error);
        })
      });
    },
    disconnectSendJim(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.post('/sendjim/disconnect', {
          company_id: data.company_id,
          user_ip: data.user_ip,
        })
        .then(response => { resolve(response.data); })
        .catch(error => { reject(error); })
      });
    },
    disconnectGhlv2(context, data) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.post('/gohighlevelv2/disconnect', {
          company_id: data.company_id,
          user_ip: data.user_ip,
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        })
      });
    },
    async saveIntegrationSettings(
      { state },
      { url = "/saveintegration", data }
    ) {
      try {
        const response = await axios({
          method: "post",
          url,
          headers: {
            Authorization: "Bearer " + state.token
          },
          data
        });
        if(response.data.result === 'error'){
          Vue.prototype.$notify({
            type: 'primary',
            message: response.data.message,
            icon: 'far fa-bug'
        });
        }else{
          Vue.prototype.$notify({
            type: 'success',
            message: response.data.message,
            icon: 'far fa-save'
        });
        }
        return response.data;
      } catch (error) {
        Vue.prototype.$notify({
          type: "primary",
          message: error.response.data.message,
          icon: "fas fa-bug"
        });
        return error.response.data
        // throw error;
      }
    },
    async updateCompanyIntegrationConfiguration(
      { state },
      { url = "/savecampaignintegrationdetails", data }
    ) {
      try {
        const response = await axios({
          method: "post",
          url,
          headers: {
            Authorization: "Bearer " + state.token
          },
          data
        });
        Vue.prototype.$notify({
          type: "success",
          message: "Changes saved successfully",
          icon: "far fa-save"
        });
        return response.data;
      } catch (error) {
        Vue.prototype.$notify({
          type: "primary",
          message: error.response.data.message,
          icon: "fas fa-bug"
        });
        // throw error;
      }
    }, 
    async getSelectedKartraListAndTags({ state }, { url = '/integration/details', data }) {
      try {
        const response = await axios({
          method: 'post',
          url,
          headers: {
            'Authorization': 'Bearer ' + state.token
          },
          data
        });    
        return response.data;
      } catch (error) {
        Vue.prototype.$notify({
          type: 'primary',
          message: error.response.data.message,
          icon: 'fas fa-bug'
      }); 
        // throw error;
      }
    }, 
    async getUserSendgridList({ state }, { url = '/sendgridlist/', companyID }) {
      try {
        const response = await axios({
          method: "get", // Changed from 'post' to 'get'
          url: url + companyID,
          headers: {
            Authorization: "Bearer " + state.token
          }
          // No data property for GET request
        });
        if (response.data) {
          return response.data.param.result;
        } else {
          return [];
        }
      } catch (error) {
        if(error.response.data.error){
          return error.response.data
        }
        return [];
        // throw error;
      }
    },  
    async getSendJimCampaignTags({ state }, { campaign_id, url = '/sendjim/getcampaigntags/' }) {
      try {
        const response = await axios({
          method: 'get',
          url: url + campaign_id,
          headers: { 'Authorization': 'Bearer ' + state.token },
        });
        if (response && response.data && response.data.result === 'success') {
          return Array.isArray(response.data.data) ? response.data.data : [];
        }
        return [];
      } catch (error) {
        return [];
      }
    },
    async getSendJimQuickSends({ state }, { company_id, url = '/sendjim/quicksends' }) {
      try {
        const response = await axios({
          method: 'get',
          url,
          headers: { 'Authorization': 'Bearer ' + state.token },
          params: { company_id }
        });
        if (response && response.data && response.data.result === 'success') {
          const payload = response.data.data || {};
          const list = Array.isArray(payload.QuickSends) ? payload.QuickSends : [];
          // normalize to { id, name, image }
          return list.map(qs => {
            const firstSeq = Array.isArray(qs.QuickSendSequences) && qs.QuickSendSequences.length > 0 ? qs.QuickSendSequences[0] : null;
            return {
              id: qs.QuickSendID || qs.Id || qs.id,
              name: qs.Name || (firstSeq && firstSeq.Name) || 'Quick Send',
              image: (firstSeq && (firstSeq.FrontImageThumbURL || firstSeq.FrontImageURL)) || '',
              raw: qs,
            };
          }).filter(it => it.id);
        }
        return [];
      } catch (error) {
        return [];
      }
    },
    async geUsertKartraList({ state }, { url = '/kartra/list/', companyID }) {
      try {
        const response = await axios({
          method: 'get', // Changed from 'post' to 'get'
          url: url + companyID,
          headers: {
            'Authorization': 'Bearer ' + state.token
          },
          // No data property for GET request
        });
        if(response.data){
          return response.data.param.lists
        }else{
          return []
        }
      } catch (error) {
        return [];
        // throw error;
      }
    },  
    async geUsertKartraDetails({ state }, { url = '/GetKartraListAndTag/', companyID }) {
      try {
        const response = await axios({
          method: 'get', // Changed from 'post' to 'get'
          url: url + companyID,
          headers: {
            'Authorization': 'Bearer ' + state.token
          },
          // No data property for GET request
        });
        if(response.data){
          return response.data.param
        }else{
          return {}
        }
      } catch (error) {
        if(error.response.data.error){
          return error.response.data
        }
        
        return [];
        // throw error;
      }
    },    
    async getUserIntegrationDetails({ state }, { url = '/getcompanyintegrationdetail/', companyID,slug }) {
      try {
        const response = await axios({
          method: "get",
          url: url + companyID + "/" + slug,
          headers: {
            Authorization: "Bearer " + state.token
          }
        });
        //if (response.data.data) {
        if (response.data) {
          return response.data;
        } else {
          //return {};
          return response.data;
        }
      } catch (error) {
        Vue.prototype.$notify({
          type: "primary",
          message: error.response.data.message,
          icon: "fas fa-bug"
        });
        // throw error;
      }
    },
    async getUserIntegrationList(
      { state },
      { url = "/getcompanyintegrationlist", companyID, companyParent }
    ) {
      try {
        const response = await axios({
          method: "get",
          url: `${url}/${companyID}/${companyParent}`,
          headers: {
            Authorization: "Bearer " + state.token
          }
        });
        if (response.data.data) {
          return response.data.data;
        } else {
          return [];
        }
      } catch (error) {
        Vue.prototype.$notify({
          type: "primary",
          message: error.response.data.message,
          icon: "fas fa-bug"
        });
        return [];
        // throw error;
      }
    },
    // agency zoom
    async getCampaignAgencyZoomDetails({ state }, { url = '/agency-zoom/getcampaignwebhook/', campaign_id }) {
      try {
        const response = await axios({
          method: "get",
          url: url + campaign_id,
          headers: {
            Authorization: "Bearer " + state.token
          }
        });
        if (response.data.data) {
          return response.data.data;
        } else {
          return {};
        }
      } catch (error) {
        Vue.prototype.$notify({
          type: "primary",
          message: error.response.data.message,
          icon: "fas fa-bug"
        });
        // throw error;
      }
    },
    async getClientAgencyZoometails({ state }, { url = '/agency-zoom/getclientwebhook/', company_id }) {
      try {
        const response = await axios({
          method: "get",
          url: url + company_id,
          headers: {
            Authorization: "Bearer " + state.token
          }
        });
        if (response.data.data) {
          return response.data.data;
        } else {
          return {};
        }
      } catch (error) {
        Vue.prototype.$notify({
          type: "primary",
          message: error.response.data.message,
          icon: "fas fa-bug"
        });
        // throw error;
      }
    },
    // agency zoom

    // zapier
    async getCampaignZapierDetails({ state }, { url = '/getcampaignwebhook/', campaign_id }) {
      try {
        const response = await axios({
          method: "get",
          url: url + campaign_id,
          headers: {
            Authorization: "Bearer " + state.token
          }
        });
        if (response.data.data) {
          return response.data.data;
        } else {
          return {};
        }
      } catch (error) {
        Vue.prototype.$notify({
          type: "primary",
          message: error.response.data.message,
          icon: "fas fa-bug"
        });
        // throw error;
      }
    },
    async getCampaignZapierTags({ state }, { url = '/getcampaigntags/', campaign_id }) {
      try {
        const response = await axios({
          method: "get",
          url: url + campaign_id,
          headers: {
            Authorization: "Bearer " + state.token
          }
        });
        if (response.data.data) {
          return response.data.data;
        } else {
          return {};
        }
      } catch (error) {
        Vue.prototype.$notify({
          type: "primary",
          message: error.response.data.message,
          icon: "fas fa-bug"
        });
        // throw error;
      }
    },
    async getAgencyZapierDetails({ state }, { url = '/getagencywebhook/', company_id }) {
      try {
        const response = await axios({
          method: "get",
          url: url + company_id,
          headers: {
            Authorization: "Bearer " + state.token
          }
        });
        if (response.data.data) {
          return response.data.data;
        } else {
          return {};
        }
      } catch (error) {
        Vue.prototype.$notify({
          type: "primary",
          message: error.response.data.message,
          icon: "fas fa-bug"
        });
        // throw error;
      }
    },
    async getAgencyZapierTags({ state }, { url = '/getagencytags/', company_id }) {
      try {
        const response = await axios({
          method: "get",
          url: url + company_id,
          headers: {
            Authorization: "Bearer " + state.token
          }
        });
        if (response.data.data) {
          return response.data.data;
        } else {
          return {};
        }
      } catch (error) {
        Vue.prototype.$notify({
          type: "primary",
          message: error.response.data.message,
          icon: "fas fa-bug"
        });
        // throw error;
      }
    },
    // zapier

    getSettingTwoFactorAuth(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get("/setting/twofactorauth/" + data.userId)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    settingTwoFactorAuth(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .put("/setting/twofactorauth/" + data.userId, {
            userId: data.userId,
            two_factor_auth: data.two_factor_auth,
            two_factor_auth_type: data.two_factor_auth_type,
            secretKey: data.secretKey,
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    verifyLogin(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .post("/verifylogin", {
            email: data.email,
            code: data.code,
            otp_token: data.otp_token,
            ownedcompanyid: data.ownedcompanyid,
            companyrootid: data.companyrootid,
          })
          .then(response => {
            if(response.data.result == 'success'){
              const token = response.data.rows.access_token;
              localStorage.setItem("access_token", token);
              context.commit("retrieveToken", token);
            }
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    resendCode(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .post("/resendcode", {
            email: data.email,
            otp_token: data.otp_token,
            companyrootid: data.companyrootid,
            ownedcompanyid: data.ownedcompanyid,
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getStopWords(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get("/bigdbm/services/configdata/" + data.company_root_id)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    getGoogleTfa(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`/setting/get-google-tfa/${data.userId}/${data.companyId}`)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    checkCampaignActive(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .post('/leadspeek/check-campaign-active', data)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    getLocationBigDbm(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get('/general/enhance/location', {
            params: {
              type: data.type,
              param: data.param,
              limit: data.limit,
              search: data.search
            }
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    async userLogSaved(
      { state },
      { url = "/general/user-log-saved", data }
    ) {
      try {
        const response = await axios({
          method: "post",
          url,
          headers: {
            Authorization: "Bearer " + state.token
          },
          data
        });
        
        return response.data;
      } catch (error) {
        
        // throw error;
      }
    }, 
    userServiceAgreementConfirm(
      { state },
      { url = "/general/user-service-agreement-confirm", data }
    ) {
      try {
        const response = axios({
          method: "post",
          url,
          headers: {
            Authorization: "Bearer " + state.token
          },
          data
        });
        
        return response.data;
      } catch (error) {
        
        // throw error;
      }
    }, 
    downloadAgreementFile(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      if (!data.user_id) {
        return Promise.reject('error')
      }
      return new Promise((resolve, reject) => {
        axios
          .post(`/general/user-service-agreement-download/${data.user_id}`, data)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    getApproxLeadCount(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`/bigdbm/services/getcountcampaign/${data.id}`)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    onApproxLeadCount(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .post('/bigdbm/services/queuecount', data)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    onApplyCampaign(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .put(`/bigdbm/services/applycampaign/${data.campaign_id}/${data.type}`, {
            keywords: data.keywords,
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    getCampaignById(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`/leadspeek/getcampaign/${data.campaign_id}`)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    getCountCampaignHistory(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`/bigdbm/services/getcountcampaignhistory/${data.campaign_id}/${data.type}`)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    runTestEmbedCode(context, data) {
      axios.defaults.headers.common["Authorization"] =
      "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`/check-run-embeded-code`, {
            params: data
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    onSendTestEmbedCode(context, data) {
      axios.defaults.headers.common["Authorization"] =
      "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .post('/check-site-embeded-code', data)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            if(error.response.status === 504){
              const responseError = {
                result: 'failed from crawl',
                status: 'not exist',
                message: 'Blocked from crawling (Needs manual review at your url)',
                msg_exist: 'Blocked from crawling (Needs manual review at your url)',
                msg_notexist: 'Blocked from crawling (Needs manual review at your url)',
                msg_block: 'Blocked from crawling (Needs manual review at your url)',
              }

             return reject(responseError)
            }
            
            reject(error.response.data);
          });
      });
    },
    onSendTestLead(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .post('/send-test-lead', data)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            if(error.response.status == 429){
              const messageErrorToManyRequest = {
                message: 'You can only attempt this test once every minute. Please try again later.'
              }
              
              return reject(messageErrorToManyRequest)
            }


            reject(error.response.data);
          });
      });
    },
    onSendTestSpreadsheet(context, data){
      const userData = context.getters.userData;

      return new  Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.put('/leadspeek/spreadsheet/check', {
          userID: userData.id,
          campaignID: data.campaignID,
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
      });
    },
    getHistorySpreadsheet(context, data){
      return new  Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.get(`/leadspeek/spreadsheet/history/${data.campaignID}`)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    onResetSpreadsheet(context, data){
      const userData = context.getters.userData;
      const userViewMode = userData.isViewMode ? userData.isViewMode : false;
      let userLogin = userData.id;
      if(userViewMode){
          const userRoot = decryptData(localStorage.getItem('userDataOri'))
          userLogin = userRoot.id;
      }

      return new  Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios.put('/leadspeek/spreadsheet/reset', {
          userLogin: userLogin,
          campaignID: data.campaignID,
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
      });
    },
    getMarketingServicesAgreement(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`/marketing-services-agreement/${data.company_id}`)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    marketingServicesAgreement(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .put(`/marketing-services-agreement`, data)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    getMarketingServicesAgreementFeature(context, data) {
      axios.defaults.headers.common["Authorization"] =
      "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`/marketing-services-agreement-feature/${data.user_id}/${data.feature_id}`)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    marketingServicesAgreementFeature(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .put(`/marketing-services-agreement-feature/${data.user_id}/${data.feature_id}`, data)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    getListTagsClickFunnels(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`/click-funnels/tags/${data.company_id}`)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    getCampaignTagsClickFunnels(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`/click-funnels/campaign/tags/${data.campaign_id}`)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    createTagsClickFunnels(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .post('/click-funnels/tags', data)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    getListCustomFields(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get('/get-custom-fields')
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    getCustomFieldsBySlug(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`/get-custom-fields/${data.slug}`)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    getStatusKeywordToTags(context, params) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get('/leadspeek/keyword-to-tags', {
            params
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    getStatusOnBoarding(context, params) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`/user/onboarding-status/${params.user_id}`)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    async getDocumentAgreementFile(context, params) {
      try {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
    
        const response = await axios.get('/document/agreement', {
          params,
        });
    
        return response.data;
      } catch (error) {
        if (error.response && error.response.data) {
          throw error.response.data;
        } else {
          throw error;
        }
      }
    },
    getCustomIntegrations(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        if(!data.company_id){
          return reject('error')
        }

        axios
          .get(`/integrations/${data.company_id}`)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    getCustomIntegrationsDetail(context, { data }) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        if(!data.company_id || !data.slug){
          return reject('error')
        }

        axios
          .get(`/integrations/${data.company_id}/${data.slug}`)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    couponCode(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .post(`/configuration/coupon/get-coupon`, data)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    async getMinSpendLatest(context, params) {
      try {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;

        const response = await axios.get(`/agreement-minimum-spend-latest/${params.company_id}`);
    
        return response.data;
      } catch (error) {
        if (error.response && error.response.data) {
          throw error.response.data;
        } else {
          throw error;
        }
      }
    },
     GetAllCampaigns(context, data) {
    
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + context.state.token;
        axios
          .get(
            `/campaigns/${data.companyID}/${data.groupCompanyID ? data.groupCompanyID : ''}`,
          )
          .then(response => {
            //context.commit('putResultData',response.data)
            //resolve('success')
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            reject(error);
          });
      });
    },
    SimplifiCreateCampaign(context, data) {      
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .post('/leadspeek/simplifi', data)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    SimplifiUpdateCampaign(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        if (!data.campaignId){
          return reject('error')
        }
        axios
          .put(`/leadspeek/simplifi/${data.campaignId}`, data)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    // GET GEO FENCES
    SimplifiGetGeoFences(context, campaignId) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get(`/leadspeek/simplifi/${campaignId}/geo-fences`)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data || error);
          });
      });
    },
    // ADD GEO FENCES
    // GET GEO FENCE RECENCY OPTIONS
    SimplifiGetGeoFenceRecencyOptions(context) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .get('/leadspeek/simplifi/geo-fence-recency-options')
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data || error);
          });
      });
    },
    SimplifiAudienceUpload(context, data) {      
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        axios
          .post('/leadspeek/simplifi/audience/upload', data)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    SimplifiGetCampaignStats(context, { data }) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        if(!data.campaign_ids){
          return reject('error')
        }
        axios
          .get(`/leadspeek/simplifi/stats`,{
            params:{
              campaign_ids: data.campaign_ids 
            }
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    SimplifiCampaignReport(context, { data }) {      
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {        
        if(!data.campaign_id || !data.client_now_date || !data.date_range){
          return reject('error')
        }
        const params = {
            campaign_id: data.campaign_id, 
            client_now_date: data.client_now_date, 
            date_range: data.date_range, 
        }
        if (data.start_date) {
          params.start_date = data.start_date
        }
        if (data.end_date) {
          params.end_date = data.end_date
        }
        axios
          .get(`/leadspeek/simplifi/campaign-reports/${data.campaign_id}`,{
            params:params
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    SimplifiGetCampaignDetails(context, { data }) {      
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        if(!data.campaign_id){
          return reject('error')
        }
        const params = {
            campaign_id: data.campaign_id, 
            client_now_date: data.client_now_date, 
            date_range: data.date_range, 
        }
        if (data.start_date) {
          params.start_date = data.start_date
        }
        if (data.end_date) {
          params.end_date = data.end_date
        }
        axios
          .get(`/leadspeek/simplifi/details`,{
            params:params
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    SimplifiGetAudience(context, { data }) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        if(!data.user_id){
          return reject('error')
        }
        axios
          .get(`/leadspeek/simplifi/audience/${data.user_id}`,{
            params:{
              selected_campaign_audience: data.selected_campaign_audience 
            }
          })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    SimplifiRemoveAudience(context, data) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        if(!data.audience_id){
          return reject('error')
        }
        axios
          .delete(`/leadspeek/simplifi/audience/${data.audience_id}`)
          .then(response => {            
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    SimplifiGetMedia(context, { data }) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        if(!data.user_id){
          return reject('error')
        }
        axios
          .get(`/media/user/${data.user_id}`)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    GetDownloadMediaToken(context, { data }) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        if(!data.media_ids){
          return reject('error')
        }
        axios
          .get(`/generate-download-token/${data.media_ids}`)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    SimplifiGetCampaignMedia(context, { data }) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        if(!data.campaign_id){
          return reject('error')
        }
        axios
          .get(`/media/campaign/${data.campaign_id}`)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    UpdateMedia(context, { data }) {      
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.state.token;
      return new Promise((resolve, reject) => {
        if(!data.media_id){
          return reject('error')
        }
        axios
          .put(`/media/${data.media_id}`,data.param || {})
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
  }
});
